<template>
  <div>
    <el-row style="margin-top: 20px">

      <el-col :xs="{span: 22, offset: 1}" :sm="{span: 22, offset: 1}" :md="{span: 20, offset: 1}" :lg="{span: 16, offset: 5}">
        <el-row>
          
          <el-col :sm="{span: 24}" :md="{span: 14}">
            <el-row>

              <transition name="fade">
                <el-col :xs="24" :sm="12" v-if="store.render.NumGenomesStat">
                  <el-tooltip effect="dark" content="Number of genomes deposited in public domain." placement="top">
                  <div class="stat" style="background-color: #0db07f">
                     <!-- @click="redirectPage('genomes')"> -->
                    <div class="sub-title">Genomes Sequenced
                      <span class="stat-icon-span"><i class="fas icon-fa-external-link-alt"></i></span>
                    </div>
                    <div class="number"> {{ numSamples }} </div>
                  </div>
                  </el-tooltip>
                </el-col>
              </transition>

              <transition name="fade">
                <el-col :xs="24" :sm="12" v-if="store.render.NumVariantsStat">
                  <el-tooltip effect="dark" content="Total number of variants identified in Indian SARS-CoV-2 genomes." placement="top">
                  <div class="stat" style="background-color: #00a99e">
                     <!-- @click="redirectPage('variants')"> -->
                    <div class="sub-title">Mutations Catalogued
                      <span class="stat-icon-span"><i class="fas icon-fa-external-link-alt"></i></span>
                    </div>
                    <div class="number"> {{ numVariants }} </div>
                  </div>
                  </el-tooltip>
                </el-col>
              </transition>
            </el-row>

            <el-row>
              <transition name="fade">
                <el-col :xs="24" :sm="12" v-show="store.render.NumLabsStat">
                  <el-tooltip effect="dark" content="Number of tracked viral lineages" placement="top">
                  <div class="stat" style="background-color: #00a0b6" @click="redirectPage('thanks')">
                    <div class="sub-title">Tracked lineages
                      <!-- <span class="stat-icon-span"><i class="fas icon-fa-external-link-alt"></i></span> -->
                    </div>
                    <div class="number"> {{ numLineages }} </div>
                  </div>
                  </el-tooltip>
                </el-col>
              </transition>

              <transition name="fade">
                <el-col :xs="24" :sm="12" v-show="store.render.NumStatesStat">
                  <el-tooltip effect="dark" content="Number of states from which at least one genome is sequenced" placement="top">
                  <div class="stat" style="background-color: #0094c4">
                     <!-- @click="redirectPage('state')"> -->
                    <div class="sub-title">States Covered
                      <!-- <span class="stat-icon-span"><i class="fas icon-fa-external-link-alt"></i></span> -->
                    </div>
                    <div class="number"> {{ numStates }} </div>
                  </div>
                  </el-tooltip>
                </el-col>
              </transition>
            </el-row>
          </el-col>

          <transition name="fade">
            <el-col :sm="{span: 24}" :md="{span: 10}" v-if="store.render.NumCladesStat">
              <div class="stat" style="background-color: #0885c4">
                <div class="sub-title">
                  Top 10 lineages
                  <!-- <el-switch 
                    style="float: right; margin-right: 20px; color: #fefefe" 
                    size="mini" v-model="cladeDataType" @change="switchCladeDataType()"
                    active-icon-class="fas icon-fa-percentage" 
                    active-value="percent" inactive-value="number" 
                    active-color="#13CE66" inactive-color="grey"
                    class="clade-datatype">
                    </el-switch> -->
                </div>
                <div class="echarts" style="width: 100%; height: 137px">
                  <v-chart :option='options' :resizable="true" theme="infographic"></v-chart>
                </div>
              </div>
            </el-col>
          </transition>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { store } from '../scripts/store.js'
import IEcharts from 'vue-echarts-v3/src/full.js'
import 'echarts/lib/chart/bar.js';

import PostService from '@/scripts/post_service.js'

const _ = require('lodash')

export default {
  name: 'MainStatistics',
  components: {
    'v-chart': IEcharts,
  },
  props: {
    msg: String
  },
  data() {
    return {
      store: store,
      cladeDataType: 'number',
    }
  },
  async mounted() {
    const context = this
  },
  computed: {
    numLabs: function() {
      return store.datasets.labs.length
    },
    numLineages: function() {
      return store.constants.pangolinLineages.length
    },
    numSamples: function() {
      return store.constants.numSamples
    },
    numVariants: function() {
      return store.constants.numVariants
    },
    numStates: function() {
      return store.constants.numStates
    },
    options: function() {

      const cladeData = store.constants.topPangolinLineagesCounts
      const clades = _.map(cladeData, "pangolin_lineage");
      const yMax = _.max(_.map(cladeData, "count"))
      const cladeCounts = _.map(cladeData, "count")

      return {
        textStyle: { fontFamily: store.theme.fontFamily.content, fontWeight: 'bold' },
        tooltip: { 
          textStyle: { fontFamily: store.theme.fontFamily.plotTooltip, color: '#4e4e4e', fontWeight: 'normal' },
          borderColor: '#bebebe', borderWidth: 1,
          backgroundColor: 'rgba(250,250,250,1)', padding: 5,
          formatter: function(d) {
            return `${d.name}<br>Genomes: ${d.value}`
          }
        },
        grid: { top: 20, bottom: 45, left: 30, right: 10, containLabels: true },
        xAxis: {
          data: clades, name: 'Clades',
          axisLabel: {
            show: true, color: '#fefefe',
            rotate: 45, 
            // formatter: function(d) { 
            //   if (d.length > 5) { return d.slice(0,3) + '..' } return d 
            // }
          },
          splitLine: { show: false },
          axisLine: { show: true, lineStyle: { color: '#fefefe' } }
        },
        yAxis: { 
          splitNumber: 2, max: yMax,
          splitLine: { show: false },
          zeroLine: {show: false}, axisLine: {show: false},
          axisTick: { lineStyle: { color: '#fefefe' } },
          axisLabel: {  show: true, color: '#fefefe', 
          formatter: function(d){ if (d % 1000 === 0) { return `${parseInt(d/1000)}K` } } },
        },
        resize: true, series: { type: 'bar', data: cladeCounts, color: '#fefefe' },
      }
    },
  },
  methods: {
    redirectPage: function (path) {
      this.$router.push(path)
    },
    switchCladeDatatype() {
      const context = this
      console.log(context.cladeDataType)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

  .stat {
    margin: 5px;
    padding: 10px;
    border-radius: 5px;
    color: #f9f9f9;
    cursor: pointer;
  }

  .stat .stat-icon-span {
    float: right;
  }

  .stat .number {
    font-size: 2em;
    font-weight: bold;
    margin-left: 5%;
  }

  .stat .sub-title {
    font-size: 0.9em;
    font-weight: bold;
    margin-left: 5%;
  }
  
  .menu-span {
    float: right;
    margin-top: 15px;
    color: white;
    font-size: 1.5em;
    cursor: pointer;
  }

  @media (max-width: 992px) {
    .desktop-only {
      display: none;
    }
  }
  .desktop-only {
    color: white;
    font-size: 1.5em;
    padding-top: 20px;
  }

  .clade-datatype .el-switch__label.el-switch__label--right {
    color: #fefefe !important;
  }
</style>
